import { AddOnServiceViewModel } from "./addOnService";
import { AmenityModel } from "./amenities";

export class AccomodationUnitTypeViewModel {
    id?: number;
    propertyId = 0;
    propertyName = "";

    name = "";
    representsWholeProperty = false;
    propertyIsAvailableViaBookingEngine = false;
    squareSize?: number;
    categoryId = 1;
    maxNumberOfAdults?: number;
    maxNumberOfChildren?: number = 0;
    maxOccupancy?: number = 0;
    quantity?: number;
    basePrice?: number;
    baseInputPrice = 0;
    damageDeposit?: number;
    depositCurrencyId?: number;
    baseBedsCapacity = 0;
    extraBedsCapacity = 0;
    currencyId = 0;
    hasOwners = false;
    propertyOwnerId?: number | null = null;
    propertyAgencyWorkModelId: number | null = null; 
    propertyOwnerPricingModelId: number | null = null;
    propertyVATCategoryForPrepaymentsId: number | null = null;
    propertyOwnerPayoutPercent: number | null = null;
    propertyOwnerPriceOffset: number | null = null;
    propertyAgencyCommissionPercentForPrepayments: number | null = null;
    propertyOwnerDoesCheckin = false;
    propertyOwnerDoesCheckout = false;
    propertyOwnerDoesCleaning = false;
    propertyCategorizationNumber: string | null = null;
    propertyCategorizationClass: string | null = null;
    propertyCategorizationDate: Date | null = null;
    iCalLink = "";

    addOnServices: AddOnServiceViewModel[] = [];
    amenities: AmenityModel[] = [];
    rooms: RoomViewModel[] = [];
    sortOrder: number | null = null;
    IsInquiryOnly = false;
}

export class RoomViewModel {
    id?: number;

    roomTypeId = 0;
    squareSize?: number;
    isShared = false

    beds: BedViewModel[] = [];
}

export class BedViewModel {
    id?: number;

    bedTypeId = 0;
    quantity = 1;
}

export type RatePlansForOfficialRatesExport = {
    id: number;
    name: string;
}

export class AccomodationUnitViewModel {
    id = 0;
    name = "";
    shortName = "";
    ownerId: number | null = null;
    ownerPriceOffset: number | null = null;
    ownerDoesCleaning = false;
    ownerDoesCheckin = false;
    ownerDoesCheckout = false;
    agencyWorkModelId: number | null = null;
    vatCategoryForPrepaymentsId: number | null = null;
    agencyCommissionPercentForPrepayments: number | null = 0;
    floor?: number;
    accomodationUnitTypeId?: number;
    sortOrder: number | null = null;
    paysCityTax = null as boolean | null;
    categorizationClass: string | null = null;
    categorizationNumber: string | null = null;
    categorizationDate?: Date | null = null;
    unlockCode: string | null = null;
    wiFiPassword: string | null = null;
    eVisitorFacilityId: number | null = null;
    kroatiDeId: number | null = null;
}

export class AccomodationUnitTypeDescription {
    id = 0;
    accomodationUnitTypeId = 0;
    cultureCode = "hr";
    accUnitTypeDescription = ""

    constructor(accomodationUnitTypeId = 0){
        this.accomodationUnitTypeId = accomodationUnitTypeId;
    }
}

export class AccomodationUnitTypeTranslation {
    id = 0;
    accomodationUnitTypeId = 0;
    cultureCode = "hr";
    nameTranslation = "";

    constructor(accomodationUnitTypeId = 0){
        this.accomodationUnitTypeId = accomodationUnitTypeId;
    }
}

export class RatePlanAccUnitType {
    id = 0;
    ratePlanId = 0;
    parentRatePlanId: number | null = null;
    ratePlanName = "";
    minPersons = 0;
    maxPersons = 0;
    minStay = 0;
    maxStay = 0;
    isDefault = false;
    isAvailableViaBookingEngine = false;
    bookingEnginePriceOffset: number | null = null;
    bookingEnginePriceOffsetPlaceholder = 0;
}

export class AccomodationUnitTypeLOSCategory{
    id = 0;
    accomodationUnitTypeId = 0;
    minStay = null as number | null;
    maxStay= null as number | null;
    isDefault = false;
    inputPriceDifference = null as number | null;
    inputPriceDifferenceIsAbsolute = null as boolean | null;
    outputPriceDifference = null as number | null;
    outputPriceDifferenceIsAbsolute = null as boolean | null;

    constructor(accomodationUnitTypeId = 0){
        this.accomodationUnitTypeId = accomodationUnitTypeId;
    }
}

export class AccomodationUnitTypePAXCategory{
    id = 0;
    accomodationUnitTypeId = 0;
    minPersons = null as number | null;
    maxPersons = null as number | null;
    inputPriceDifference = null as number | null;
    inputPriceDifferenceIsAbsolute = null as boolean | null;
    outputPriceDifference = null as number | null;
    outputPriceDifferenceIsAbsolute = null as boolean | null;

    isDefault = false;

    constructor(accomodationUnitTypeId = 0, isDefault = false){
        this.accomodationUnitTypeId = accomodationUnitTypeId;
        this.isDefault = isDefault;
    }
}
